const SideBarRoutes = [
  {
    name: "Overview",
    icon: "overview",
    function: true,
    functionName: "Overview",
    layout: "",
    hideFromSidebar: true,
  },
  {
    name: "Sign Out",
    icon: "Logout",
    function: true,
    functionName: "Logout",
    layout: "",
    hideFromSidebar: true,
  },
];

export default SideBarRoutes;
